export function returnToHome() {
    window.location.href = '/';
}
